export class FeedForm extends HTMLElement {
	static {
		if (window.customElements.get("feed-form") === undefined) {
			window.customElements.define("feed-form", FeedForm);
		}
	}

	#dialog;

	get [Symbol.toStringTag]() {
		return this.tagName;
	}

	constructor() {
		super();

		this.setAttribute("data-js", "true");

		this.#dialog = /** @type {HTMLDialogElement} */ (
			this.querySelector(".js-FeedForm-dialog")
		);
		this.#dialog.open = false;
	}

	connectedCallback() {
		this.querySelector(".js-FeedForm-openButton")?.addEventListener(
			"click",
			() => {
				if (this.#dialog.open) {
					this.#dialog.close();
				} else {
					this.#dialog.show();
				}
			},
		);
		this.querySelector(".js-FeedForm-closeButton")?.addEventListener(
			"click",
			() => {
				this.#dialog.close();
			},
		);

		const form = /** @type {HTMLFormElement} */ (
			this.querySelector(".js-FeedForm-form")
		);
		// Remove the “checked” attribute from all inputs so that the form's reset button unchecks _all_ inputs including those which are already checked on page load.
		for (const input of /** @type {NodeListOf<HTMLInputElement>} */ (
			form.querySelectorAll("input[type='checkbox'][checked]")
		)) {
			// Removing the “checked” attribute unchecks a checked input **if it wasn't checked through a user interaction or the IDL attribute before**. This is the case when loading a page with inputs having a “checked” attribute. To keep the inputs checked while still allowing the reset button to uncheck all of them requires propagating the checked state from the content attribute to the IDL attribute.
			input.checked = true;
			input.removeAttribute("checked");
		}
	}
}
